<template>
  <div class="city-selector" @click="handleClick">
    <span class="city-name">{{ city }}</span>
    <img src="../assets/close.png" alt="Close" class="icon close-icon" />
  </div>
</template>

<script>
export default {
  name: "CitySelector",
  props: {
    city: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClick() {
      this.$emit("openRegionSelection");
    },
  },
};
</script>

<style scoped>
.city-selector {
  display: inline-flex;
  align-items: center;
  background: #686868;
  padding: 4px 8px;
  border-radius: 999px;
  font-family: "Eastman", sans-serif;
  font-weight: 500;
  font-size: 11px;
  color: #ffffff;
  white-space: nowrap;
  cursor: pointer;
}

.icon {
  height: 12px;
}

.city-name {
  margin-right: 8px;
  margin-left: 8px;
}

.close-icon {
  width: 7px;
  height: 7px;
}
</style>